import { Tab, Tabs } from "@blueprintjs/core";
import * as React from "react";
import { DoublonContactLieuxFormation, DoublonContactSiegesSociaux } from ".";
import { useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IDoublonContactPageProps {}

export const DoublonContactPage: React.FunctionComponent<IDoublonContactPageProps> = props => {
  const { t } = useTl();
  const [tab, setTab] = React.useState("siegesSociaux");

  return (
    <Tabs
      id="TabsDoublonContact"
      onChange={newTabId => setTab(newTabId + "")}
      selectedTabId={tab}
      renderActiveTabPanelOnly
      vertical
    >
      <Tab id="siegesSociaux" title={t(ETLCodes.SiegesSociaux)} panel={<DoublonContactSiegesSociaux />} />
      <Tab id="lieuxFormation" title={t(ETLCodes.LieuxFormations)} panel={<DoublonContactLieuxFormation />} />
    </Tabs>
  );
};
